// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"35b98833","52":"16b56a03","128":"6e892411","296":"66194699","319":"7ae9a7d6","355":"6dbbb88a","413":"90de3c2e","581":"d64b96d6","653":"b036c8a3","710":"6965a14e"}[chunkId] + ".chunk.js";
};